import { render, staticRenderFns } from "./CourseAssignment.vue?vue&type=template&id=735830b3&scoped=true"
import script from "./CourseAssignment.vue?vue&type=script&lang=js"
export * from "./CourseAssignment.vue?vue&type=script&lang=js"
import style0 from "./CourseAssignment.vue?vue&type=style&index=0&id=735830b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735830b3",
  null
  
)

export default component.exports